'use client';

import Image from '@src/components/atoms/safe-image';

import Modal from '@src/components/atoms/modal'
import BeatLoader from '@src/components/atoms/beat-loader';

// Assets
import XIcon from '@public/png/x-1.png';
import Magnifying from "@public/png/magnifying-1.png"
import ArrowLeft from "@public/png/arrow-left-2.png"
import IArrowRight1 from "@public/svg/i-arrow-right"

import React from "react";

const highlightText = (text, highlight) => {
  if (!highlight) return text;
  if (!text) return "";

  const parts = text.split(new RegExp(`(${highlight})`, "gi"));

  return (
    <span>
      {parts.map((part, i) => (
        <span
          key={i}
          style={part.toLowerCase() === highlight.toLowerCase() ? { fontFamily: "Satoshi Bold" } : {}}
        >
          {part}
        </span>
      ))}
    </span>
  );
};

const Option = ({ search, currentVal, lastItemRef, slug, ...props }) => {
  return (
    <button
      ref={lastItemRef}
      className="w-full font-satoshi flex items-center justify-between py-4 text-[17px] border-b-[0.5px] border-dashed border-[#E6E7E8]"
      {...props}
    >
      {highlightText(currentVal, search)}

      <div className="flex items-center gap-2">
        <p className="bg-[#EBF0F7] rounded-[4px] px-2 py-0.5 font-satoshi text-[11px]/[15.6px] tracking-[0.11px] text-[#3268AE]">{slug}</p>
        <div className="w-4 h-4 flex items-center justify-center">
          <IArrowRight1 color="#686A68" width={16} height={16} />
        </div>
      </div>
    </button>
  );
};

const ModalSearchListListing = ({
  onClose,
  value,
  onChange,
  lastItemRef,
  data,
  onSelect,
  isFetching,
  ...props
}) => {
  const [onFocus, setOnFocus] = React.useState(false)
  const [startTyping, setStartTyping] = React.useState(false)

  return (
    <Modal {...props} onClose={onClose} className="!items-start dd2-xl:hidden">
      <div className='relative mt-[56px] z-[42] w-[460px] rounded-[12px] bg-white p-6'>
        <button className='absolute z-[43] p-1 -top-8 right-0 flex justify-center items-center bg-white rounded'>
          <Image
            width={16}
            height={16}
            src={XIcon}
            alt='Close'
            className='object-contain'
            onClick={onClose}
          />
        </button>

        <p className='text-[21px] font-satoshi-bold mb-2'>Properti di mana?</p>

        <div className='h-[40px] rounded-[8px] flex items-center'>
          <input className='h-[48px] w-[calc(100%-40px)] font-satoshi border border-solid border-[#E6E7E8] border-r-0 p-[12px] rounded-l-[8px] text-[17px]
            placeholder:text-[#808285]'
            placeholder='cari "Setiabudi" atau "Jakarta Selatan"'
            value={value}
            onChange={(e) => {
              onChange(e)
              setStartTyping(true)
            }}
            onFocus={() => setOnFocus(true)}
            onBlur={() => setOnFocus(false)}
          />
          <div className='h-[48px] flex items-center justify-center border border-solid border-[#E6E7E8] border-l-0 p-[12px] rounded-r-[8px]'>
            <Image
              width={24}
              height={24}
              src={Magnifying}
              alt='Search'
              className='object-contain'
            />
          </div>
        </div>

        {(onFocus || !!value) && <p className="font-satoshi text-[11px]/[15.6px] tracking-[-0.11px] text-[#686A68] mt-2">Cari berdasarkan area atau kota. Pilih dari daftar yang muncul.</p>}

        {!!value && (
          <div>
            <div id="scrollable-list" className='max-h-[420px] overflow-y-auto scrollbar-hide'>
              {data.map((item, idx) => (
                <Option 
                  onClick={() => onSelect(item)} 
                  key={`${item.id}-${idx}`} 
                  slug={item.slug} 
                  search={value} 
                  currentVal={item.name} 
                />
              ))}
              
              {/* Loading Sentinel positioned before the keyword option */}
              {data.length > 0 && (
                <div 
                  ref={lastItemRef}
                  style={{ height: '5px', width: '100%', margin: '5px 0' }} 
                />
              )}

             {!data.length && <div onClick={() => onSelect({name: value, slug: "Keyword"})} className="flex items-center justify-between gap-2 border-b-[0.5px] border-dashed border-[#DEDFDE] py-4">
                <p className="font-satoshi text-[17px]/[23.8px] tracking-[0.17px] text-[#040704]">{value}</p>

                <div className="flex items-center gap-2">
                  <p className="bg-[#EBF0F7] rounded-[4px] px-2 py-0.5 font-satoshi text-[11px]/[15.6px] tracking-[0.11px] text-[#3268AE]">Kata Kunci</p>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <IArrowRight1 width={16} height={16} />
                  </div>
                </div>
              </div>}

              {/* Loader */}
              {isFetching ? <div>
                <div className="flex items-center gap-2 justify-between py-4">
                  <p className="font-satoshi text-[14px]/[19.6px] text-[#040704]">Sedang mencari lokasi...</p>
                  <BeatLoader />
                </div>
              </div> : null}

              {/* No Data */}
              {!isFetching && startTyping && data?.length === 0 ? <div>
                <div className="flex items-start gap-4 justify-between py-4">
                  <p className="font-satoshi text-[14px]/[19.6px] text-[#040704]">Lokasi tidak ditemukan. Coba ketik area/kota lain atau gunakan kata kunci.</p>
                  <BeatLoader />
                </div>
              </div> : null}
            </div>
          </div>
        )}
      </div>
    </Modal>
  )
}

const ModalSearchListListingMobile = ({ onClose, value, onChange, lastItemRef, data, onSelect, isFetching, ...props }) => {
  const [onFocus, setOnFocus] = React.useState(false)
  const [startTyping, setStartTyping] = React.useState(false)

  return (
    <Modal {...props} onClose={onClose} className="!items-start hidden dd-xl:flex">
      <div className='z-[42] w-screen h-screen bg-white p-4 overflow-y-auto'>
        <div className='h-[40px] rounded-[8px] flex items-center'>
          <button className='w-[40px] h-[40px] mr-4 flex justify-center items-center bg-[#F6F6F6] rounded'>
            <Image
              width={20}
              height={20}
              src={ArrowLeft}
              alt='Close'
              className='object-contain'
              onClick={onClose}
            />
          </button>

          <div className='w-full h-[40px] flex items-center justify-between border border-solid border-[#252526] rounded p-[12px]'>
            <input className='w-[calc(100%-40px)] text-[17px] font-satoshi
            placeholder:text-[#808285]'
              placeholder="Masukkan kota/area"
              value={value}
              onChange={(e) => {
                onChange(e)
                setStartTyping(true)
              }}
              onFocus={() => setOnFocus(true)}
              onBlur={() => setOnFocus(false)}
            />
            <Image
              width={24}
              height={24}
              src={Magnifying}
              alt='Search'
              className='object-contain'
            />
          </div>
        </div>

        {(onFocus || !!value) && <p className="font-satoshi text-[11px]/[15.6px] tracking-[-0.11px] text-[#686A68] mt-2">Cari berdasarkan area atau kota. Pilih dari daftar yang muncul.</p>}

        {!!value && <div>
          <div id="scrollable-list-mobile" className="overflow-y-auto">

            {data.map((item, idx) => (
              <Option
                onClick={() => onSelect(item)}
                key={`${item.id}-${idx}`}
                slug={item.slug}
                search={value}
                currentVal={item.name}
              />
            ))}
            
            {/* Loading Sentinel Element - this is what triggers infinite loading */}
            {data.length > 0 && (
              <div 
                ref={lastItemRef}
                style={{ height: '5px', width: '100%', margin: '5px 0' }} 
              />
            )}

           {!data.length && <div onClick={() => onSelect({name: value, slug: "Keyword"})} className="flex items-center justify-between gap-2 border-b-[0.5px] border-dashed border-[#DEDFDE] py-4">
              <p className="font-satoshi text-[17px]/[23.8px] tracking-[0.17px] text-[#040704]">{value}</p>

              <div className="flex items-center gap-2">
                <p className="bg-[#EBF0F7] rounded-[4px] px-2 py-0.5 font-satoshi text-[11px]/[15.6px] tracking-[0.11px] text-[#3268AE]">Kata Kunci</p>
                <div className="w-4 h-4 flex items-center justify-center">
                  <IArrowRight1 width={16} height={16} />
                </div>
              </div>
            </div>}

            {/* Loader */}
            {isFetching ? 
              <div className="flex items-center gap-2 justify-between py-4">
                <p className="font-satoshi text-[14px]/[19.6px] text-[#040704]">Sedang mencari lokasi...</p>
                <BeatLoader />
              </div>
            : null}

            {/* No Data */}
            {!isFetching && startTyping && !data?.length ? <div>
              <div className="flex items-start gap-4 justify-between py-4 w-full">
                <p className="font-satoshi text-[14px]/[19.6px] text-[#040704]">Lokasi tidak ditemukan. Coba ketik area/kota lain atau gunakan kata kunci.</p>
                <BeatLoader />
              </div>
            </div> : null}
          </div>
        </div>}
      </div>
    </Modal>
  )
}

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null
  return (
    <>
      <ModalSearchListListing isOpen={isOpen} {...props} />
      <ModalSearchListListingMobile isOpen={isOpen} {...props} />
    </>
  )
}

export default Wrapper